import { MonitorKey } from '../monitor-models/monitor-key.type';

export class TimelineRequestParameters {

    public MonitorKeys: MonitorKey[];
    public Date: Date;

    constructor(keys: MonitorKey[], date: Date) {
        this.MonitorKeys = keys;
        this.Date = date;
    }

}
